import React from 'react';
import { SupportAttachment } from './SupportAttachment';
import './SupportAttachmentListStyles.scss';
const baseClass = 'qmb-ui-ai-support-attachment-list';
/**
 * The files of one support message, on either side of the conversation: images as inline
 * thumbnails that open in the lightbox, everything else as chips. One component so the agent's
 * files and the customer's own look and behave the same.
 */
export function SupportAttachmentList({ attachments, resolveUrl, align = 'start' }) {
    if (attachments.length === 0)
        return null;
    return (React.createElement("div", { className: `${baseClass} ${baseClass}--${align}`, "data-testid": "support-attachment-list" }, attachments.map((attachment) => (React.createElement(SupportAttachment, { key: attachment.id, attachment: attachment, resolveUrl: resolveUrl })))));
}
